<template>
    <div>

        <dropdown-confirmation
                size="lg"
                direction="left"
                triggerBtnClass="btn-clear"
                triggerBtnHtml='<i class="fa fa-sliders"></i>'
                confirmBtnClass="btn-primary"
                confirmBtnHtml='<i class="fa fa-check"></i>&nbsp;&nbsp;OK'
                hasEmpty
                alertMode
                @confirm="confirm"
        >
            <slot>
                <div>
                    <span class="label">
                        <label>Timeframe:</label>
                    </span>


                    <div class="timeframe-chooser text-right" v-show="value.timeframe != 'Custom'">
                        <dropdown class="float-right" :list="timeframes" hasEmpty v-model="value.timeframe"  ></dropdown>
                    </div>

                    <div class="date-picker-form-control" v-show="value.timeframe == 'Custom'">
                        <datepicker
                                v-model="value.start"
                                name="start_begin"
                                input-class="form-control"
                                format="MM-dd-yy"
                                :highlighted="todaysDate"
                                placeholder="Start"
                        ></datepicker>
                    </div>
                    <div class="date-picker-form-separator" v-show="value.timeframe == 'Custom'">
                        -
                    </div>
                    <div class="date-picker-form-control" v-show="value.timeframe == 'Custom'">
                        <datepicker
                                v-model="value.end"
                                name="start_end"
                                input-class="form-control"
                                placeholder="End"
                                format="MM-dd-yy"></datepicker>
                    </div>

                    <div class="date-picker-form-separator" v-show="value.timeframe == 'Custom'">
                        <i class="fa fa-remove" @click="resetValues"></i>
                    </div>
                </div>
                <div>

                    <span class="label">
                        <label>Group By:</label>
                    </span>


                    <div class="timeframe-chooser text-right">
                        <dropdown class="float-right" :list="groups" hasEmpty v-model="value.group"></dropdown>
                    </div>

                </div>
                <button class="bottom btn btn-sm btn-clear" @click="resetAll">Reset Values</button>

            </slot>
        </dropdown-confirmation>

        <span v-show="value.timeframe">{{value.timeframe}} BY {{value.group}}</span>

    </div>

</template>
<script type="text/babel">
    import Dropdown from '../assets/Dropdown.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "TimeFrame",
        data() {
            return {
                todaysDate:{
                    to: new Date().setHours(23,59,59,999),
                    from: new Date().setHours(0,0,0,0)
                },
            }
        },
        components:{
            DropdownConfirmation,
            Dropdown,
            Datepicker
        },
        created(){
            console.log(this.value);

        },
        computed:{
        },
        methods:{
            confirm(){
                this.$emit('input', this.value);
            },
            resetValues(){
                this.value.end = '';
                this.value.start='';
                this.value.timeframe = '';
            },
            resetAll(){
                this.value.end = '';
                this.value.start='';
                this.value.timeframe = '';
                this.value.group = '';
            }
        },
        props: {
            timeframes:{
                type: Array,
                required: true
            },
            groups:{
                type: Array,
                required: true
            },
            value:{
                type: Object,
                required: true
            }
        }
    }
</script>
<style scoped>
    .label{
        display: inline-block;
        width: 100px;
        padding-top: 10px;
        vertical-align: middle;
        margin-top: 10px;

    }
    .date-picker-form-separator{
        padding-top: 10px;
    }
    .timeframe-chooser{
        vertical-align: middle;
        margin-top: 10px;
        display: inline-block;

    }
    .bottom {
        position: absolute;
        bottom: 20px;
        left: 20px;
    }
</style>


// WEBPACK FOOTER //
// Timeframe.vue?40b58b60